import { render, staticRenderFns } from "./ConfirmationOverlay.vue?vue&type=template&id=70f17830&scoped=true"
import script from "./ConfirmationOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmationOverlay.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationOverlay.vue?vue&type=style&index=0&id=70f17830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f17830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
